export class NetworkServerGroupModel {
  owner: string = "";
  name: string = "";
  protocolVersion: string = "";
  netIds: Array<string>;
  devAddrRange: Array<string>;

  constructor(
    owner: string = "",
    netIds: Array<string> = [],
    devAddrRange: Array<string> = [],
    name: string = "",
    protocolVersion: string = "") {
    this.owner = owner;
    this.name = name;
    this.netIds = netIds;
    this.devAddrRange = devAddrRange;
    this.protocolVersion = protocolVersion;
  }

  addNetId(netId: string) {
    this.netIds.push(netId)
  }

  editNetId(index: string, value: string) {
    this.netIds[index] = value;
  }

  removeNetId(index) {
    this.netIds.splice(index, 1);
  }
}
